import { HttpCode } from 'src/models/api/enums/HttpErrorCode'

export class InvalidPinCode extends Error {
  message = 'validations.invalid_pincode'
}
export class GeneralError extends Error {
  message = 'error_general'
}
export class ConnectivityError extends Error {
  message = 'api.exception.connectivity'
}
export class NetworkApiError extends Error {
  message = 'api.exception.offline'
  code = HttpCode.ERR_NETWORK
}

export class CanceledApiError extends Error {
  message = 'api.exception.forced_canceled'
  code = HttpCode.ERR_CANCELED
}

export class TimeoutApiError extends Error {
  message = 'api.exception.timeout'
  code = HttpCode.ECONNABORTED
}

export class GeneralApiError extends Error {
  message = 'api.exception.general'
}

export class BadRequestError extends Error {
  message = 'api.exception.bad_request'
}

export class UnauthorizedError extends Error {
  message = 'api.exception.unauthorized'
}

export class ForbiddenError extends Error {
  message = 'api.exception.forbidden'
}

export class NotFoundError extends Error {
  message = 'api.exception.not_found'
}

export class ConflictError extends Error {
  message = 'api.exception.conflict'
}

export class TooManyRequestsError extends Error {
  message = 'api.exception.too_many_request'
}

export class ServiceUnavailableError extends Error {
  message = 'api.exception.service_unavailable'
}

export class NoUnitsAvailableError extends Error {}

export class UnitUnavailableError extends Error {}

export class NoLockersAvailableError extends Error {}

export class InvalidDomainNameError extends Error {}

export class WorkflowNotActiveError extends Error {}

export class WorkflowNotFoundError extends Error {}

export class InvalidOccupancyDurationError extends Error {}

export class RentalInOvertimeError extends Error {}

export class RentalNotOngoingError extends Error {}

export class RentalAlreadyHasAuthenticationTypeError extends Error {}

export class InvalidAuthenticationCodeError extends Error {}
export class InvalidReservationTokenError extends Error {}

export class ReservationAlreadyInUse extends Error {}
export class ReservationPickupNotAllowed extends Error {}

export class CartExpiredError extends Error {}
export class OrderCancelledError extends Error {}
export class OrderPaymentExpiredError extends Error {}
export class OrderAlreadyPaidError extends Error {}

export class LocationDifferentFromCurrentOrderLocationError extends Error {}
export class InvalidOrderStateError extends Error {}
export class InvalidOrderItemStateError extends Error {}
export class LockerOpeningFailedError extends Error {}
